import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import VesselInvaders from './VesselInvaders'

export const VesselInvadersPage: FC = () => {
  const navigate = useNavigate()
  return <VesselInvaders onClose={() => navigate(PATHS.arcade.url)} />
}
